<template>
  <div class="list-template">
    <el-table
      class="list-template-table"
      :ref="tableOptions.tableName || tableDefault.tableName"
      :data="tableList"
      :border="tableOptions.border || tableDefault.border"
      @selection-change="handleSelectionChange"
      :row-class-name="tableRowClassName"
      :max-height="tableOptions.height || maxHeight"
      highlight-current-row
      :show-summary="tableOptions.showSummary"
      :summary-method="
        tableOptions.summaryColumns && tableOptions.summaryColumns.length > 0
          ? tableOptions.summaryMethod || tableDefault.summaryMethod
          : undefined
      "
      header-row-class-name="table-header"
      @row-click="rowClick"
    >
      <!--多选-->
      <el-table-column
        v-if="tableOptions.showSelect"
        type="selection"
        width="55"
      ></el-table-column>
      <!--索引-->
      <el-table-column
        align="center"
        v-if="tableOptions.indexShow || tableDefault.indexShow"
        type="index"
        width="60"
        label="序号"
        :index="tableOptions.indexMethod || tableDefault.indexMethod"
      ></el-table-column>
      <template v-for="(column, index) in tableOptions.columns">
        <el-table-column
          :key="index"
          v-if="column.hidden == true ? false : true"
          :class-name="column.class"
          :property="column.prop"
          :label="column.label"
          :align="column.align || tableOptions.align"
          :min-width="column.width || tableOptions.align"
          :sortable="column.sortable || false"
          :show-overflow-tooltip="column.type !== 'image'"
        >
          <template slot-scope="scope">
            <template v-if="column.merge">
              <span v-for="(p, index) in column.prop.split(',')" :key="index">{{
                scope.row[p]
              }}</span>
            </template>
            <img
              class="table-img"
              :title="scope.row[column.prop]"
              :class="{ cursor: column.click }"
              v-else-if="column.type && column.type === 'image'"
              @click="btnCommon(column, scope.row)"
              :src="
                column.defaultValue
                  ? column.defaultValue
                  : scope.row[column.prop]
              "
            />
            <div
              v-else-if="column.enumData"
              v-html="$utils.getEnumItem(column, scope.row[column.prop])"
            ></div>
            <div
              @click="itemClick(column, scope.row)"
              v-else-if="column.callback"
              class="td-click"
              :title="column.title"
            >
              {{ scope.row[column.prop] }}
            </div>
            <div
              class="deal"
              v-else-if="column.deal"
              v-html="column.deal(scope.row, column, scope.$index)"
              @click="itemClick(column, scope.row)"
            ></div>
            <!--            <progress-bar-->
            <!--              v-else-if="column.type === 'progress'"-->
            <!--              :column='column'-->
            <!--              :row="scope.row"-->
            <!--            ></progress-bar>-->
            <el-progress
              v-else-if="column.type === 'progress'"
              :text-inside="true"
              :stroke-width="16"
              :percentage="parseInt(scope.row[column.prop] * 100)"
              :status="scope.row[column.prop] < 0 ? 'exception' : 'success'"
            ></el-progress>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="toolConfig.length > 0"
        label="操作"
        align="center"
        :fixed="tableOptions.fixed || tableDefault.fixed"
        :width="tableOperateWidth"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-for="btn in toolConfig"
            v-show="btn.filter ? btn.filter(scope.row) : true"
            :key="btn.name || btn.label"
            @click="btnCommon(btn, scope.row)"
          >{{ btn.name || btn.label }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <div class="fl total-cue">所有记录</div>
      <div class="fl total-cue">{{ page.total }}条</div>
      <!--分页-->
      <el-pagination
        class="tr"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-size="page.pageSize"
        :page-sizes="tableOptions.pageList || [10, 15, 20, 30, 40, 100, 200]"
        :layout="tableOptions.layout || 'prev, pager, next, jumper'"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
  import table from "@/mixin/table.js";

  export default {
    mixins: [table],
    // components: { progressBar },
    props: {
      tableOptions: {
        type: Object,
        default: () => {
          return [];
        }
      },
      toolConfig: {
        type: Array,
        default: () => {
          return [];
        }
      },
      sumEntity: {}
    },
    data() {
      return {
        sumEntityChildren:this.sumEntity,
        maxHeight: document.documentElement.clientHeight - 180 - 160,
        percentage: [],
        tableList: [],
        tableOperateWidth: 0,
        page: {
          current: 1,
          total: 0,
          pageSize: 10
        },
        searchParams: {}
      };
    },
    methods: {
      initData(params) {
        this.searchParams = params;
        console.log(params, "**************");
        this.getTableData();
      },
      // 设置条数
      handleSizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.page.current = 1;
        this.getTableData();
      },
      // 翻页
      handleCurrentChange(value) {
        this.page.current = value;
        this.getTableData();
      },
      rowClick(row, column, event) {
        let refName = this.tableOptions.tableName || this.tableDefault.tableName;
        if (this.tableOptions.isRowClick) {
          this.$emit("rowClick", row, refName);
        }
      },
      setCurrentRow(refName, row) {
        //设定某一行为选中行，如果调用时不加参数，则会取消目前高亮行的选中状态
        if (row) {
          this.$refs[refName].setCurrentRow(row);
        } else {
          this.$refs[refName].setCurrentRow();
        }
      },
      getTableData() {
        if (!this.tableOptions.url) return;
        if (this.tableOptions.params) {
          Object.assign(this.searchParams, this.tableOptions.params)
        }
        this.$axios
          .fetchPost(this.tableOptions.url, {
            ...this.searchParams,
            ...{
              pageNumber: this.page.current,
              pageSize: this.page.pageSize
            }
          })
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.tableList = data.data.records;
              this.page.total = data.data.total;
              if (data.data.sumEntity) {
                this.sumEntityChildren = data.data.sumEntity;
              }
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },
      handleSelectionChange(val) {
        this.selectRow = val;
      }
    }
  };
</script>
<style>
  .list-template .el-table .cell {
    height: 33px;
    line-height: 33px;
  }

  .list-template .el-table__body {
    border-bottom: 1px solid #ccc;
  }

  /*进度条底色*/
  .el-progress-bar__outer {
    background-color: #ccc;
  }

  .list-template-table div::-webkit-scrollbar {
    width: 8px;
    height: 10px;
    margin-top: 10px;
  }

  .list-template-table .deal {
  }

  /*排序数字*/
  .list-template-table .sort-num-green {
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    background: #ecf5ff;
    color: #65a9fc;
    border: 1px solid #deeeff;
    border-radius: 50%;
    line-height: 20px;
  }

  .list-template-table .sort-num-orange {
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    background: #fff7e8;
    color: #f9a93a;
    border: 1px solid #fef1d9;
    border-radius: 50%;
    line-height: 20px;
  }

  .list-template .pagination-box {
    /*position: absolute;*/
    /*left: 0;*/
    /*bottom: 0px;*/
    width: 100%;
    padding: 0 20px;
    /*line-height: 37px;*/
  }

  .list-template .el-input.el-pagination__editor.is-in-pagination {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/purchaseListTemplate.vue